import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const LoadingReducer = (state = { loadingOperations: [], caption: undefined }, { type, payload, }) => {
    switch (type) {
        case MultichainActionType.ADD_TO_LOADING_LIST: {
            const loadingPayload = payload;
            if (state.loadingOperations.find((loadingItem) => loadingItem.name === (loadingPayload === null || loadingPayload === void 0 ? void 0 : loadingPayload.operation))) {
                const newState = { loadingOperations: [...state.loadingOperations] };
                for (let loadingOperation of newState.loadingOperations) {
                    if (loadingOperation.name === (loadingPayload === null || loadingPayload === void 0 ? void 0 : loadingPayload.operation)) {
                        loadingOperation.done = false;
                    }
                }
                return newState;
            }
            else {
                const newState = {
                    loadingOperations: [...state.loadingOperations],
                    caption: state.caption,
                };
                newState.loadingOperations.push({
                    name: loadingPayload.operation,
                    operationParams: loadingPayload.operationParams,
                    hideDots: loadingPayload.hideDots,
                    done: false,
                });
                return newState;
            }
        }
        case MultichainActionType.REMOVE_FROM_LOADING_LIST: {
            const loadingPayload = payload;
            const newState = {
                loadingOperations: [...state.loadingOperations],
                caption: state.caption,
                loadingPercentage: state.loadingPercentage,
            };
            for (let loadingOperation of newState.loadingOperations) {
                if (loadingOperation.name === (loadingPayload === null || loadingPayload === void 0 ? void 0 : loadingPayload.operation)) {
                    loadingOperation.done = true;
                }
            }
            return newState.loadingOperations.some((loadingOperation) => loadingOperation.done === false)
                ? newState
                : {
                    loadingOperations: [],
                    caption: undefined,
                    loadingPercentage: undefined,
                };
        }
        case MultichainActionType.ADD_CAPTION_TO_LOADING_PAGE: {
            const setCaptionPayload = payload;
            const newState = {
                loadingOperations: [...state.loadingOperations],
                caption: setCaptionPayload.caption,
                loadingPercentage: state.loadingPercentage,
            };
            return newState;
        }
        case MultichainActionType.ADD_LOADING_PERCENTAGE: {
            const setLoadingPercentagePayload = payload;
            const newState = {
                loadingOperations: [...state.loadingOperations],
                caption: state.caption,
                loadingPercentage: setLoadingPercentagePayload.loadingPercentage,
            };
            return newState;
        }
        default:
            return state;
    }
};
